module.exports = __webpack_public_path__ + "static/media/sell_rent_2b.dcde05f4.png";